module.exports = __webpack_public_path__ + "static/media/Signup_Flow1.86d16117.png";